'use strict';

angular.module('msAssessment').component('msAssessmentQuestion', {
  template: '<div ng-include="vm.getTemplateUrl()"></div>',
  controller: assessmentQuestionCtrl,
  controllerAs: 'vm',
  bindings: {
    assessment: '<',
    translatePrefix: '<',
    selectFn: '<',
    questionIndex: '<'
  }
});

assessmentQuestionCtrl.$inject = ['assessmentRouter', 'wellnessSvc', '$window', '$timeout', '$translate', 'NotifyingSvc', 'pageTitleSvc'];

function assessmentQuestionCtrl(assessmentRouter, wellnessSvc, $window, $timeout, $translate, NotifyingSvc, pageTitleSvc) {
  var vm = this;
  vm.$onInit = _activate;
  vm.hasFinalQuestionSubmit = false;
  // vm.jawsReady - for jaws related dom actions
  vm.jawsReady = false;

  function _activate() {
    vm.translatePrefix = vm.translatePrefix || 'onboarding';
    //wire up global event subscriber for page title changes
    pageTitleSvc.registerEventListeners();
    //set page title only after translation is available
    $translate.onReady(function () {
      setPageTitle();
    });
    // If the user tries to start the assessment on anything other than question 1,
    // they get sent back to question 1.
    if (vm.questionIndex > 1 && wellnessSvc.getTotalAnsweredCount() === 0) {
      assessmentRouter.navigateNextQuestion({
        question: 1,
        assessment: 1
      });
    } else {
      vm.questionIndex = vm.questionIndex || 1;
      // Assumes the assessment questions have been sorted correctly before being passed as binding.
      vm.question = vm.assessment.questions[vm.questionIndex - 1];
      vm.optionIndices = _.range(vm.question.scaleStartPosition, vm.question.scaleStartPosition === 0 ? vm.question.scaleSize : vm.question.scaleSize + 1);

      var n = vm.assessment.categories.filter(function (category) {
        return category.id === vm.question.categoryId;
      })[0];
      vm.legend = _.get(n, 'legend');

      var previousAnswer = wellnessSvc.getAssessmentAnswer(vm.assessment, vm.question.id);
      if (previousAnswer !== undefined) {
        vm.previousAnswer = previousAnswer;

        //WCAG hack to set focus on previous answer after rendering completes
        $timeout(function () {
          var element = $window.document.getElementById("assessment_btn_" + vm.previousAnswer);
          if (element) {
            element.focus();
          }
        });
      }
    }

    setJawsReady();
  }

  ////////////////////////////////////

  vm.getTemplateUrl = function () {
    var questionType = vm.question ? vm.question.questionType : 'config_scale';
    return 'assessments/templates/question.' + questionType.toLowerCase() + '.html';
  };

  vm.assessmentButtonPress = function (option) {
    vm.jawsReady = false;

    // If is last question prevent multiple submit
    if (!vm.hasFinalQuestionSubmit) {
      vm.selectFn(option);
    }

    // Detect final question submit
    if (parseInt(vm.questionIndex) === vm.assessment.questions.length) {
      vm.hasFinalQuestionSubmit = true;
    }

    setJawsReady();
  };

  function setJawsReady() {
    var jawsTimeout = 750;
    $timeout(function () {
      vm.jawsReady = true;
    }, jawsTimeout);
  }

  function setPageTitle() {
    $translate(["pageTitles.questionnaire"], { currentQuestion: vm.questionIndex, length: vm.assessment.questions.length }).then(function (res) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
        pageTitle: res["pageTitles.questionnaire"]
      });
    });
  }
}